import React, { useState } from 'react';
import { useStripe, useElements, CardElement, Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Modal, ModalBody, ButtonToolbar } from 'reactstrap';
import classNames from 'classnames';
import CardSection from './CardSection';
import Button from '@material-ui/core/Button';
import { Tooltip } from '@material-ui/core';
import CCIcon from 'mdi-react/CreditCardIcon';
const stripePromise = loadStripe(process.env.STRIPE_PUB_KEY);

function InnerCardSetupModal(props) {
  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async function (e) {
	e.preventDefault();
	if (!stripe || !elements || loading) return;

	setLoading(true);
	setError(false);

	const result = await stripe.confirmCardSetup(props.clientSecret, {
	  payment_method: {
		card: elements.getElement(CardElement),
		billing_details: {
		  name: props.user.name,
		  email: props.user.email
		}
	  }
	});

	if (result.error) {
	  setError(result.error.message || 'Card setup failed');
	  setLoading(false);
	} else {
	  props.onComplete();
	}
  };

  const modalClass = classNames({
	'modal-dialog--colored': false,
	'modal-dialog--header': true
  });

  return (
	<Modal
	  isOpen={props.isOpen}
	  toggle={props.onClose}
	  modalClassName="ltr-support"
	  className={'modal-dialog--primary ' + modalClass}
	>
	  <form onSubmit={handleSubmit}>
		<div className="modal__header">
		  <button className="lnr lnr-cross modal__close-btn" type="button" onClick={props.onClose} />
		  <h4 className="text-modal modal__title">Add a Payment Method</h4>
		</div>
		<ModalBody>
		<div className="modal__message-container">
		  <h5>No Credit Card on File</h5>
		  <p>To continue, please add a credit card. It will be stored securely and charged when purchases are needed.</p>
		</div>
		  <div className="cc-title">Enter Credit Card Information</div>
		  <div className="card-input">
			<CardSection />
		  </div>
		  {error && <div className="payment-error mt-2">{error}</div>}
		</ModalBody>
		<ButtonToolbar className="modal__footer">

		  <Tooltip title="Cancel">
			  <Button
				   onClick={props.onClose}
				   variant="outlined"
				   color=""
				   className=""
				   startIcon={null}
				   style={{marginRight:10}}
			   >	Cancel
			   </Button>
			</Tooltip>{' '}
		  <Tooltip title="Update Credit Card">
			  <Button
				   onClick={handleSubmit}
				   variant="contained"
				   color="primary"
				   className="buyersList__primary-button"
				   startIcon={<CCIcon />}
			   >	{loading ? 'Adding Card...' : 'Add Card'}
			   </Button>
			</Tooltip>
		</ButtonToolbar>
	  </form>
	</Modal>
  );
}

export default function StripeCardSetupModal(props) {
  return (
	<Elements stripe={stripePromise} options={{ clientSecret: props.clientSecret }}>
	  <InnerCardSetupModal {...props} />
	</Elements>
  );
}
